import { motion } from 'framer-motion';
import { Droplets, Scissors, Sparkles, Cat, Heart } from 'lucide-react';

const services = [
  {
    id: 'banho',
    title: 'Banho',
    description: 'Banho completo com produtos de qualidade, secagem e escovagem. Deixamos o seu patudo cheiroso e feliz.',
    icon: Droplets,
    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhMg3zzXAQMkF4dk9bFEQQ4_FJiz2cdMCsu1Vz5JLGwS2oEuiWiSPVhs5Tc7A6XxbE5mJ3osQRUhAadi0TSAOmlFg6Aq3C3E4CUtt5tQtX4XV9JbvzZTlR59qOXyp_Q5XsMcsdPgAEAShKucPgCXlB5qbIQftcNAUphoup1v4dJAXCtDJ4binBcgBXC3tXF/w477-h268/cachorro_pode_tomar_banho_no_frio.jpg',
    span: 'md:col-span-2',
    color: 'from-blue-400/20 to-cyan-400/20',
  },
  {
    id: 'tosquia',
    title: 'Tosquia',
    description: 'Corte profissional adaptado à raça e estilo do seu animal, com todo o cuidado e paciência.',
    icon: Scissors,
    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgXacfo5ox2c2vQBWM4nABFqI-L3ZQ0G4FGdK-NH0OERslAWnowyTeK42INgPclAoLNuomYeZ9m-sGDkUXHnkAuvE6k_0iiCeZmjf_aj4qIteYYA2CYkHsIoIQbTX2OFU6vBOIWfKpFca9Q0-Ptek1SYx8w-PXSodQwGfvl0qIHVC-s6nfxq_3FMWc2turW/w387-h257/capa-tosa.jpg',
    span: 'md:col-span-1',
    color: 'from-purple-400/20 to-pink-400/20',
  },
  {
    id: 'pack',
    title: 'Pack Completo',
    description: 'Banho + Tosquia + Corte de unhas. O tratamento completo para o seu melhor amigo.',
    icon: Sparkles,
    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhDfz7ZrZm3RPSC4GSJVlrg0aJbRDykLgZHdN3L-_ZRhK_QH5y4isbCQfFI4SFoLLxrVo9Zhwk1ciHfnff3cV-mDlR8oDdIKS67jvOX1O86-DTKtXDif8hks6aqRcwjkbHxhybEJ0zW5ab2ckrUdcG5xKuCvSydtXxemxDFCvT9n7Md4EAiH0ztNM0AnX-6/w431-h244/shutterstock_144255763-970x550.jpg',
    span: 'md:col-span-1',
    color: 'from-yellow-400/20 to-orange-400/20',
  },
  {
    id: 'gatos',
    title: 'Higiene e Estética Canina',
    description: 'Tratamentos de higiene e estética adaptados à raça, pelagem e necessidades do seu cão.',
    icon: Cat,
    image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEi_8s6-Vm5a2JUgLCjFI-NR6EBWCBf9HNxEpsgNjOw_dX4jpun0-222jRwug6J9nUc7zbGjEt23IRUahgNEQOFvSZQj2WAKqufbilCHiOeF1oGYAQdfGXNBnTPUZctmBj8dcaTlahYay0pomUGK7QipDbPhF1_V7OPqfPFNYo2VvnivCKSlaSTj8Rgkwtls/w537-h227/7978f067fc3fffc51ed5e3f0d5d714d2.jpg',
    span: 'md:col-span-2',
    color: 'from-green-400/20 to-emerald-400/20',
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
    },
  },
};

export const Services = () => {
  return (
    <section 
      id="servicos" 
      className="py-20 md:py-28 bg-gradient-to-b from-white to-yellow-50/50 relative overflow-hidden"
      data-testid="services-section"
    >
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-200/30 rounded-full blur-3xl -z-10" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <motion.div
          className="text-left mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="inline-flex items-center gap-2 text-yellow-600 font-semibold mb-4">
            <Heart className="w-4 h-4" />
            Os nossos serviços
          </span>
          <h2 className="font-nunito text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Tratamos cada animal<br />
            <span className="text-yellow-500">como se fosse nosso</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl">
            Cada animal é único. Aqui, respeitamos o tempo, o conforto e a personalidade de cada patudo.
          </p>
        </motion.div>

        {/* Services Bento Grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {services.map((service) => (
            <motion.div
              key={service.id}
              className={`${service.span} group relative bg-white rounded-3xl overflow-hidden shadow-xl shadow-black/5 border border-gray-100`}
              variants={cardVariants}
              whileHover={{ y: -8, scale: 1.02 }}
              transition={{ duration: 0.3 }}
              data-testid={`service-card-${service.id}`}
            >
              {/* Image */}
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${service.color} to-transparent opacity-60`} />
                
                {/* Icon badge */}
                <motion.div
                  className="absolute top-4 left-4 w-14 h-14 bg-white rounded-2xl shadow-lg flex items-center justify-center"
                  whileHover={{ rotate: 10, scale: 1.1 }}
                >
                  <service.icon className="w-7 h-7 text-yellow-600" />
                </motion.div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="font-nunito text-xl font-bold text-gray-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>

              {/* Hover overlay */}
              <div className="absolute inset-0 bg-yellow-500/0 group-hover:bg-yellow-500/5 transition-colors duration-300 pointer-events-none" />
            </motion.div>
          ))}
        </motion.div>

        {/* Additional info */}
        <motion.div
          className="mt-12 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
        >
          <div className="inline-flex items-center gap-3 bg-yellow-100 text-yellow-800 px-6 py-3 rounded-full">
            <Sparkles className="w-5 h-5" />
            <span className="font-medium">Espaço inclusivo e acolhedor</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
